import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Select,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { API, Headers } from "../../Config";
var width = window.innerWidth;
function FormModal(props) {
  const Auth = useSelector((state) => state.Auth.user);
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    LoadAccounts();
  }, []);

  const onFinish = (values) => {
    setLoading(true);
    let requestObj = {
      userid: Number(values.userid),
      note: values.note,
      head: values.head,
      amount: Number(values.amount),
      expense_amount: values.amount.toString(),
      date: values.date,
      account_no: values.account_no,
      fromAccount: values.account_no,
      created_by: parseInt(Auth.id),
    };

    let URL =
      props.mode === "post"
        ? API.EXPANCE_ENTRY_ACTIONS
        : API.EXPANCE_ENTRY_ACTIONS + props.item.id;
    axios({
      method: props.mode,
      url: API.BASR_URL + URL,
      headers: Headers(),
      data: requestObj,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.onchange();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  const LoadAccounts = () => {
    let api =
      API.BASR_URL +
      "chart_of_accounts/child_accountsBySalesExpense/" +
      Auth.id +
      "/expense";
    fetch(api, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((accnt) => {
        setAccounts(accnt);
      })
      .catch((error) => {
        console.log("LoadAccounts Error ===>>", error);
      });
  };


  return (
    <div>
      <Drawer
        placement={props.mode === "post" ? "right" : "left"}
        title={
          <span className="txt4">
            {props.mode === "post" ? "New" : "Update"} Expance
          </span>
        }
        width={width / 2.7}
        onClose={() => props.onClose()}
        visible={props.visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form
          layout="horizontal"
          hideRequiredMark
          onFinish={onFinish}
          initialValues={{
            userid: props.item && props.item.userid,
            account_no: props.item && props.item.account_no,
            note: props.item && props.item.note,
            head: props.item && props.item.head,
            amount: props.item && props.item.amount,
            date: props.item && moment(props.item.date),
          }}
        >
          <Container>
            <Row>
              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                name="date"
                label="Date"
                rules={[{ required: true, message: "required" }]}
              >
                <DatePicker
                  placeholder="Pick a date"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                name="account_no"
                label={<div className="form-item-label">Account</div>}
                rules={[{ required: true, message: "Account is required" }]}
              >
                <Select
                  placeholder="Select Account"
                  showSearch
                  filterOption={(input, option) => {
                    const accountText = `${option.account_no} - ${option.account_name}`;
                    return accountText
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  optionFilterProp="children"
                >
                  {accounts.map((option) => (
                    <Select.Option
                      key={option.account_no}
                      value={option.account_no}
                      account_no={option.account_no}
                      account_name={option.account_name}
                    >
                      {option?.account_no} - {option?.account_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                name="userid"
                label={<div className="form-item-label">User</div>}
                rules={[{ required: true, message: "User is required" }]}
              >
                <Select
                  placeholder="Select User"
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLocaleLowerCase()) >= 0
                  }
                >
                  {props.user.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                name="head"
                label={<div className="form-item-label">Head</div>}
                rules={[{ required: true, message: "Head is required" }]}
              >
                <Input placeholder="" />
              </Form.Item>

              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                name="note"
                label={<div className="form-item-label">Remarks</div>}
                rules={[{ required: false, message: "required" }]}
              >
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                name="amount"
                label={<div className="form-item-label">Amount</div>}
                rules={[{ required: true, message: "Amount is required" }]}
              >
                <InputNumber placeholder="enter amount" />
              </Form.Item>
            </Row>
          </Container>
          <Row>
            <Col sm="6" xs="12"></Col>
            <Col sm="3" xs="12">
              <Button block onClick={() => props.onClose()}>
                Cancel
              </Button>
            </Col>
            <Col sm="3" xs="12">
              <Button block type="primary" htmlType="submit" loading={loading}>
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
}

export default FormModal;
